import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const useActivityGoalMaster = create((set) => ({
  activityGoalTagData: [],
  getActivityGoalTagData: async () => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['activityGoalTagData'],
        queryFn: async () => {
          const { data } = await httpRequest(
            'get',
            `${envConfig.api_url}/master/get-mbf-goal-tag`,
            {},
            true
          );
          return data;
        },
        staleTime: Infinity,
      });

      if (Array.isArray(data) && data?.length > 0) {
        const unitDataCopy = data.map((val) => {
          return { value: val?.id ?? '', name: val?.goal_name ?? '' };
        });
        set({
          loading: false,
          activityGoalTagData: unitDataCopy,
        });
      }
      set({ loading: false });
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.response?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
}));
